class ProductMedia extends HTMLElement {
    // connect component
    connectedCallback() {
        const self = this;
        const breakpoint = window.matchMedia("(max-width: 990px)");
        let productMediaSlider;
        const zoomHandlers = new Map();
        const checkBreakpoint = function () {
            const allSliders = self.querySelectorAll('.swiper-product-media');
            allSliders.forEach(slider => {
                if (slider.dataset.desktopLayout === "slider") {
                    enableSlider(slider);
                } else {
                    // display in stacked format on desktop
                    if (breakpoint.matches === false) {
                        disableSlider(slider);
                        // Scroll to initial image on page load for stacked layout
                        scrollToInitialImage(slider);
                    // display in slider format on mobile
                    } else if (breakpoint.matches === true) {
                        if (!slider.classList.contains("swiper-initialized")) {
                            enableSlider(slider);
                        }
                    }
                }
                const enableZoomSetting = self.dataset.enableZoom !== 'false';
                if (enableZoomSetting && breakpoint.matches === false) {
                    return enableZoom(slider);
                // don't enable zoom on mobile or when zoom is disabled.
                } else {
                    return disableZoom(slider);
                }
            });
        }
        const enableSlider = function (slider) {
            const sliderId = slider.id;
            slider.classList.remove("product-grid");
            let slideCount = slider.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)").length;
            const thumbsId = `${sliderId}--thumbs`;

            // Get initial slide from data attribute (set by Liquid based on selected variant)
            const initialSlide = parseInt(slider.dataset.initialSlide) || 0;

            let thumbsSwiper;
            if (document.getElementById(thumbsId)) {
                thumbsSwiper = new Swiper(`#${thumbsId}`, {
                    loop: false,
                    slidesPerView: 5,
                    spaceBetween: 5,
                    initialSlide: initialSlide,
                    centerInsufficientSlides: true
                });
            }
            if (slideCount > 1) {
                const enableZoomSetting = self.dataset.enableZoom !== 'false';
                const swiperOptions = {
                    loop: true,
                    initialSlide: initialSlide,
                    pagination: {
                        el: `#${sliderId} .swiper-pagination`,
                        clickable: true
                    },
                    navigation: {
                        nextEl: `#${sliderId} .swiper-button-next`,
                        prevEl: `#${sliderId} .swiper-button-prev`
                    },
                    thumbs: {
                        swiper: thumbsSwiper,
                    },
                };
                if (enableZoomSetting) {
                    swiperOptions.zoom = {
                        maxRatio: 5,
                        containerClass: 'swiper-zoom-container'
                    };
                }
                productMediaSlider = new Swiper(`#${sliderId}`, swiperOptions);
            }
        }

        const disableSlider = function () {
            if (productMediaSlider !== undefined) {
                productMediaSlider.destroy(true, true);
            }
        }

        const scrollToInitialImage = function (slider) {
            // Only scroll on initial page load, not every time layout changes
            if (slider.dataset.initialScrollDone) return;
            slider.dataset.initialScrollDone = 'true';

            const initialSlide = parseInt(slider.dataset.initialSlide) || 0;
            if (initialSlide === 0) return; // Already at first image

            const slides = slider.querySelectorAll('.swiper-slide');
            if (slides[initialSlide]) {
                const targetSlide = slides[initialSlide];
                const stickyHeader = document.querySelector('sticky-header');
                const headerOffset = stickyHeader ? stickyHeader.offsetHeight : 0;

                const scrollPosition = targetSlide.getBoundingClientRect().top + window.pageYOffset - headerOffset;
                window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
            }
        }

        const enableZoom = function (container) {
            const productGrid = container.closest('#MainProduct');
            if (productGrid) productGrid.classList.add("product-grid");
            let slides = container.querySelectorAll('.swiper-zoom-container');
            Array.from(slides).forEach((slide) => {
                const onMouseMove = function (event) {
                    const x = event.offsetX / slide.offsetWidth * 100
                    const y = event.offsetY / slide.offsetHeight * 100
                    slide.style.backgroundPosition = x + '% ' + y + '%';
                }
                // remove zoom
                const onMouseOut = function () {
                    slide.removeEventListener("mousemove", onMouseMove);
                    slide.removeEventListener("mouseout", onMouseOut);
                    slide.classList.remove("js-zoom-container");
                    slide.style.backgroundImage = "";
                }
                const onZoomClick = function () {
                    let imageUrl = slide.children[0].src;
                    slide.style.backgroundImage = `url(${imageUrl})`;
                    slide.classList.add("js-zoom-container");
                    slide.addEventListener("mousemove", onMouseMove);
                    slide.addEventListener("mouseout", onMouseOut);
                }
                slide.addEventListener("click", onZoomClick);
                zoomHandlers.set(slide, onZoomClick);
            });
        }

        const disableZoom = function (container) {
            let slides = container.querySelectorAll('.swiper-zoom-container');
            Array.from(slides).forEach((slide) => {
                const handler = zoomHandlers.get(slide);
                if (handler) {
                    slide.removeEventListener("click", handler);
                    zoomHandlers.delete(slide);
                }
            });
        }

        breakpoint.addListener(checkBreakpoint);
        checkBreakpoint(); // first check
    }
}


customElements.define('product-media', ProductMedia);